import { api, authHeader } from "../configs/axiosConfigs";

const InvoicesApiService = {
  getMyInvoices: async () => {
    const response = await api.request({
      url: `/api/Invoices/GetMyInvoices`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getInvoiceDetails: async (invoiceId) => {
    const response = await api.request({
      url: `/api/Invoices/GetInvoiceWithItems?id=${invoiceId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  createInvoiceFromOrder: async (orderId) => {
    const response = await api.request({
      url: `/api/Invoices/CreateInvoiceFromOrder?orderId=${orderId}`,
      method: "POST",
      headers: authHeader(),
    });
    return response.data;
  },

  getOrderInvoices: async (orderId) => {
    const response = await api.request({
      url: `/api/Invoices/GetOrderInvoices?orderId=${orderId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  updateInvoiceStatus: async (invoiceId, status) => {
    const response = await api.request({
      url: `/api/Invoices/UpdateInvoiceStatus?id=${invoiceId}&status=${status}`,
      method: "PUT",
      headers: authHeader(),
    });
    return response.data;
  },
};

export default InvoicesApiService;
